import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "../feature/cartReducer";
import dataReducer from "../feature/dataReducer";
import paymentReducer from "../feature/paymentReducer";

import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage";

const cartPersistConfig = {
  key: "cart",
  storage,
};

const persistedCartReducer = persistReducer(cartPersistConfig, cartReducer);

const store = configureStore({
  reducer: {
    data: dataReducer,
    cart: persistedCartReducer,
    paymentButton: paymentReducer,
  },
  middleware: [thunk],
});

export const persistor = persistStore(store);

export default store;
